<template>
	<div class="session-list-item ui-elevation-1 panel">
		<div class="session-list-item__wrapper">
			<div class="session-list-item__video">
				<div v-if="session.established === 1 && streamServer" style="height: inherit;">
					<web-player-stream
						:setup-wait="15000"
						:show-unavailable="false"
						:stream="{
							server: streamServer,
							site: site,
							streamId: session.stream_id,
							title: streamTitle
						}"
					/>
				</div>
			</div>
		</div>
		<stream-statistics
			:session="session"
			:stream-title="streamTitle"
			@toggleFavorite="toggleFavorite"
			@stop="$emit('stop', session)"
		/>
	</div>
</template>

<script>
import StreamStatistics from "StreamStatistics";
import WebPlayerStream from "lib/components/WebPlayerStream";

import alert from "lib/modules/Alert";
import http from "lib/modules/Http";

export default {
	name: "SessionItemStream",
	components: {
		StreamStatistics,
		WebPlayerStream
	},
	props: {
		session: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			site: location.host,
			streamServer: null,
			streamTitle: ""
		};
	},
	created() {
		http.get(`/api/v2/recorder/stream/${this.session.stream_id}`)
		.then((response) => {
			this.streamServer = response.data.stream_server.hostname;
			this.streamTitle = response.data.title;
		})
		.catch((error) => {
			alert.error("Unable to get stream", error.response);
		});
	},
	methods: {
		toggleFavorite() {
			$bus.$emit("_session/ui/FavoriteDialog.open", this.session.contact);
		}
	}
};
</script>

<style lang="scss" scoped>
.session-list-item {
	position: relative;
	grid-column: span 1;
	display: grid;
	grid-auto-flow: column;
	grid-template-columns: none;
	grid-template-rows: auto 1fr;
	order: 1;
	.session-list-item__wrapper {
		background-color: #000;
		padding-top: 56.25%; /* 16:9 Aspect Ratio */
		position: relative;
		width: 100%;
		align-self: center;
		order: 0;
		.session-list-item__video {
			position: absolute;
			top: 0;
			left: 0;
			height: 100%;
			width: 100%;
		}
	}
}
// 2 columns
@media (min-width: 656px) {
	.session-list-item {
		grid-column: span 2
	}
}
// 3 columns - video | stats on column
@media (min-width: 962px) {
	.session-list-item {
		grid-column: span 3;
	}
}
// 3 columns - video | stats on row
@media (min-width: 1200px) {
	.session-list-item {
		grid-column: span 4;
		grid-auto-flow: row;
		grid-template-columns: 1fr 340px;
		grid-template-rows: none;
		.session-list-item__video {
			max-width: 1280px;
			order: 0;
		}
	}
}

// IE11 specific, using flex due to poor grid support
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
	.session-list-item {
		display: flex;
		flex-direction: column;
		margin: 8px;
		.session-list-item__video {
			width: 100%;
			order: 0;
		}
	}
	// 3 columns
	@media (min-width: 1200px) {
		.session-list-item {
			flex-direction: row;
			max-width: 1280px;
		}
	}
}
</style>
